import {createSelector} from '@store/@common';

import SkillStore from 'stores/SkillStore';

const baseSkillState = createSelector(SkillStore);

export const usedSkills = createSelector([baseSkillState], store => store.usedSkills);

export const areSkillsFetching = createSelector([baseSkillState], store => store.areSkillsFetching);

export const skillsByTeamList = createSelector([baseSkillState], store => store.skillsByTeamList);
